import { Campaign, GetCampaignParams } from '@features/campaigns';
import { useCurrentUser } from '@features/users';
import {
  buildDimensionTableData,
  buildPresentation,
  useLciReportFields,
} from '@features/lci-report';
import { GetLci3ReportParams } from '@components/Dashboard/dashboardSlice/campaignsApi';
import { clientDefaultValues } from '@features/lci-report/subdomains/visitation/utils/client-default-values';
import { LciReportDownloadButton } from './LciReportDownloadButton';
import { presentationToFile } from '@features/powerpoint';
import { stringify } from 'qs';
import { useNavigate } from 'react-router-dom';

type VisitationLciReportDownloadButtonProps = {
  campaignId: Campaign['id'];
  campaignParams: Omit<GetCampaignParams, 'id'>;
  reportParams: Omit<GetLci3ReportParams, 'id'>;
};

export const VisitationLciReportDownloadContainer = (
  props: VisitationLciReportDownloadButtonProps
) => {
  const navigate = useNavigate();
  const { role: userRole } = useCurrentUser();

  const { data, loading } = useLciReportFields({
    campaignParams: {
      ...props.campaignParams,
      id: props.campaignId,
    },
    reportParams: props.reportParams,
  });

  const handleDownload = () => {
    if (!data) throw new Error('Missing data for presentation');

    const presentation = buildPresentation({
      ...data,
      brandLogo: null,
      dimensionTableData: buildDimensionTableData(data.subdimensions),
      customFields: clientDefaultValues(
        data.campaign.name,
        data.visitMetrics,
        data.salesSummary
      ),
    });

    if (userRole === 'user') {
      void presentationToFile(presentation);
      return;
    } else {
      void navigate(
        `/campaigns/v3/${props.campaignId}/lci-report?${stringify({ ...props.campaignParams, ...props.reportParams })}`
      );
    }
  };

  return (
    <LciReportDownloadButton
      loading={loading}
      userRole={userRole}
      onDownload={handleDownload}
      startIcon={loading ? '...' : undefined}
    />
  );
};
